import { render, staticRenderFns } from "./TextCell.vue?vue&type=template&id=17943434&scoped=true&"
import script from "./TextCell.vue?vue&type=script&lang=js&"
export * from "./TextCell.vue?vue&type=script&lang=js&"
import style0 from "./TextCell.vue?vue&type=style&index=0&id=17943434&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17943434",
  null
  
)

export default component.exports